import { CdkAccordionModule } from "@angular/cdk/accordion";
import { DecimalPipe, NgClass } from "@angular/common";
import { Component, inject, input, InputSignal } from "@angular/core";
import { MatIconModule } from "@angular/material/icon";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { take } from "rxjs";
import { ApiService } from "../../../../../../../api/api.service";
import { CropWithDotsCenterPipe } from "../../../../../../pipes/crop-with-dots-center.pipe";
import { AuthService } from "../../../../../../services/auth.service";
import { ReportStatusComponent } from "../../../../../report-status/report-status.component";
import { CreateReferralLinkRequest, ReportEntity, Top10Data } from "../../../../../../../api/api.model";
import { CopyToClipboardCopiedDirective } from "../../../../../../directives/copy-to-clipboard-copied.directive";
import { CopyButtonComponent } from "../../../../../copy-button/copy-button.component";
import { CutNumberPipe } from "../../../../../../pipes/cut-number.pipe";

@Component({
  selector: 'app-top-10-list',
  standalone: true,
  imports: [
    CdkAccordionModule,
    MatIconModule,
    ReportStatusComponent,
    CropWithDotsCenterPipe,
    NgClass,
    TranslateModule,
    CopyToClipboardCopiedDirective,
    CopyButtonComponent,
    CutNumberPipe
],
  templateUrl: './top-10-list.component.html',
  styleUrl: './top-10-list.component.scss'
})
export class Top10ListComponent {
  public readonly report: InputSignal<ReportEntity<Top10Data>> = input.required();
  private readonly _apiService: ApiService = inject(ApiService);
  private readonly _authService: AuthService = inject(AuthService);
  private readonly _matSnackBar: MatSnackBar = inject(MatSnackBar);
  private readonly translateService: TranslateService = inject(TranslateService);

  ngOnInit() {
    console.log(this.report());
  }

  public createReferral(address: string): void {
    const body: CreateReferralLinkRequest = {
      // TODO: Проверить правильны ли подставляется id
      // name: `tg-${ this._authService.telegramUserId() }`,
      name: `tg-${ this._authService.accountDto()?.user?.telegramChatId }`,
      targetWallet: address
    };
    this._apiService.createReferral(body).pipe(take(1)).subscribe({
      next: () => {
        const snackConfig: MatSnackBarConfig = {
          panelClass: 'break-words'
        }
        this._matSnackBar.open('The unique invitation link was created', 'Close', snackConfig);
      }
    });
  }
}
